import React, { useState } from 'react';
import DoubleTapImage from './DoubleTapImage';

const DoubleTapTest = () => {
  const [testImage] = useState({
    id: 'test-1',
    cloudinary_public_id: 'sample/photo-1',
    alt_text: 'Test image'
  });
  
  const [likeCount, setLikeCount] = useState(0);
  const [clickCount, setClickCount] = useState(0);

  const handleLike = (imageId, isLiked) => {
    console.log('Like event:', { imageId, isLiked });
    setLikeCount(prev => prev + 1);
  };

  const handleClick = () => {
    console.log('Single click event');
    setClickCount(prev => prev + 1);
  };

  return (
    <div className="p-8 max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-4">Double Tap Test</h2>
      
      <div className="mb-4 p-4 bg-gray-100 rounded">
        <p><strong>Instructions:</strong></p>
        <ul className="list-disc list-inside text-sm">
          <li>Single tap to view (should increment click count)</li>
          <li>Double tap to like (should increment like count and show heart animation)</li>
        </ul>
      </div>

      <div className="mb-4">
        <p><strong>Stats:</strong></p>
        <p>Single clicks: {clickCount}</p>
        <p>Likes: {likeCount}</p>
      </div>

      <div className="w-64 h-64">
        <DoubleTapImage
          image={testImage}
          isLiked={false}
          onLike={handleLike}
          onClick={handleClick}
        />
      </div>

      <div className="mt-4 text-sm text-gray-600">
        <p>Check the browser console for detailed event logs.</p>
      </div>
    </div>
  );
};

export default DoubleTapTest; 